import { HttpClient } from '@angular/common/http';
import { APP_INITIALIZER, CSP_NONCE, inject, NgModule, provideAppInitializer } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { CoreModule } from '@core';
import { environment } from '@env';
import { NgRXStoreModule, TaxillaLibraryModule } from 'taxilla-library';

import * as configuration from '../../environments/configuration.json';
import { AppRoutingModule } from './app-routing.module';
import { components } from './components';
import { AppComponent } from './components/app/app.component';
import { CustomsnackbarComponent } from './components/customsnackbar/customsnackbar.component';
import { LoaderComponent } from './components/loader/loader.component';
import { PasswordexpireComponent } from './components/passwordexpire/passwordexpire.component';
import { PostLoginFooterComponent } from './components/postloginfooter/postloginfooter.component';
import { RedirectComponent } from './components/redirect/redirect.component';
import { getNonce } from './csp-nonce.provider';
import { CspStyleNonceService } from './csp-style-nonce.service';

export function closeMatSelectOnPsScroll(): () => void {
    return () => {
        const handler = () => {
            (document.querySelector('.cdk-overlay-backdrop') as HTMLElement)?.click();
        };
        document.addEventListener('ps-scroll-y', handler, true);
        document.addEventListener('ps-scroll-x', handler, true);
    };
}

export function initApp(http: HttpClient) {
    return () => {
        const origin = window.location.origin;
        const isLocalWithPort = window.location.hostname.includes('local.') && !!window.location.port;
        let config = {};

        function resolveConfigs(response) {
            Object.assign(environment, response);
        }

        if (isLocalWithPort) {
            resolveConfigs(configuration);
            return Promise.resolve();
        }

        return http
            .get(origin + '/ui-config')
            .toPromise()
            .then(res => {
                config = res;
            })
            .catch(() => {
                config = configuration;
            })
            .finally(() => {
                resolveConfigs(config);
            });
    };
}

@NgModule({
    declarations: [
        AppComponent,
        LoaderComponent,
        CustomsnackbarComponent,
        PostLoginFooterComponent,
        RedirectComponent,
        PasswordexpireComponent,
        ...components,
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        RouterModule,
        MatIconModule,
        MatCardModule,
        TaxillaLibraryModule,
        AppRoutingModule,
        MatProgressSpinnerModule,
        MatDialogModule,
        MatMenuModule,
        MatButtonModule,
        NgRXStoreModule,
        CoreModule,
    ],
    providers: [
        provideAppInitializer(() => {
            const initializerFn = initApp(inject(HttpClient));
            return initializerFn();
        }),
        {
            provide: CSP_NONCE,
            useFactory: getNonce,
        },
        CspStyleNonceService,
        {
            provide: APP_INITIALIZER,
            useFactory: closeMatSelectOnPsScroll,
            multi: true,
        },
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
